/* Read More – Paired mode: {{ visible }} + [[ hidden ]]
   - Pairs each {{ ... }} with the NEXT [[ ... ]], adding a button UNDER the visible block.
   - Hidden chunks keep their original HTML formatting.
   - Unpaired [[ ... ]] get their own button.
   - Nested pairs inside hidden content are supported.
   - Works with the html.rm-prep anti-FOUC hook in theme.liquid.
*/
(function () {
  'use strict';

  var SELECTORS = '.rte, .rich-text__text, .product__description, .article__content, .page__content, .collection-hero__description, .collection__description';
  // Match {{ ... }} OR [[ ... ]] (non-greedy, multiline-safe)
  var TOKEN_RE = /(\{\{[\s\S]*?\}\}|\[\[[\s\S]*?\]\])/g;

  function stripTags(s) { return s.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim(); }
  function firstHeadingText(html) {
    var m = html.match(/<h[1-6][^>]*>([\s\S]*?)<\/h[1-6]>/i);
    return m ? stripTags(m[1]) : '';
  }
  function escAttr(s) {
    return String(s).replace(/[&"<'>]/g, function (c) {
      return ({ '&':'&amp;', '"':'&quot;', "'":"&#39;", '<':'&lt;', '>':'&gt;' })[c];
    });
  }

  function buildPaired(html) {
    TOKEN_RE.lastIndex = 0;
    var tokens = [], m;
    while ((m = TOKEN_RE.exec(html)) !== null) {
      var raw = m[1];
      var type = raw.startsWith('{{') ? 'visible' : 'hidden';
      var inner = raw.slice(2, -2); // remove {{}} or [[]]
      tokens.push({ type, start: m.index, end: m.index + raw.length, inner });
    }
    if (tokens.length === 0) return null;

    var out = '', cursor = 0;
    for (var i = 0; i < tokens.length; i++) {
      var t = tokens[i];
      if (cursor < t.start) out += html.slice(cursor, t.start); // unmarked region

      if (t.type === 'visible') {
        var vis = t.inner;
        var nxt = tokens[i + 1];
        if (nxt && nxt.type === 'hidden') {
          var hid = nxt.inner;
          var uid = 'rm-' + Math.random().toString(36).slice(2);
          var label = firstHeadingText(hid);
          if (label.length > 60) label = label.slice(0, 57) + '…';
          label = label ? ('Read more: ' + label) : 'Read more';

          // Wrap as a pair so the button is reliably UNDER the visible block
          out += '<div class="rm-pair">';
          out += '<div class="rm-visible">' + vis + '</div>';
          out += '<button class="rm-toggle" type="button" aria-expanded="false" aria-controls="' + uid + '" data-orig-label="' + escAttr(label) + '">' + escAttr(label) + '</button>';
          out += '<div id="' + uid + '" class="rm-rest" hidden>' + hid + '</div>';
          out += '</div>';

          cursor = nxt.end;
          i++; // skip the hidden we consumed
          continue;
        } else {
          // No paired hidden: just render the visible as-is (no wrapper)
          out += vis;
          cursor = t.end;
          continue;
        }
      } else {
        // Hidden with no preceding visible → standalone button + hidden
        var solo = t.inner;
        var uid2 = 'rm-' + Math.random().toString(36).slice(2);
        var label2 = firstHeadingText(solo);
        if (label2.length > 60) label2 = label2.slice(0, 57) + '…';
        label2 = label2 ? ('Read more: ' + label2) : 'Read more';

        out += '<div class="rm-pair">';
        out += '<button class="rm-toggle" type="button" aria-expanded="false" aria-controls="' + uid2 + '" data-orig-label="' + escAttr(label2) + '">' + escAttr(label2) + '</button>';
        out += '<div id="' + uid2 + '" class="rm-rest" hidden>' + solo + '</div>';
        out += '</div>';

        cursor = t.end;
        continue;
      }
    }
    if (cursor < html.length) out += html.slice(cursor); // tail

    return out;
  }

  function containsMarkers(s) { return /(\{\{[\s\S]*?\}\}|\[\[[\s\S]*?\]\])/.test(s); }

  function processOne(el) {
    if (el.dataset.rmProcessed === '1') return;

    var html = el.innerHTML;
    var transformed = buildPaired(html);
    if (transformed !== null) {
      el.innerHTML = transformed;
    }
    el.dataset.rmProcessed = '1';

    // Recursively process nested pairs inside hidden blocks until none remain
    var safety = 10;
    while (safety-- > 0) {
      var more = false;
      el.querySelectorAll('.rm-rest').forEach(function (rest) {
        if (containsMarkers(rest.innerHTML)) {
          var inner = buildPaired(rest.innerHTML);
          if (inner !== null) {
            rest.innerHTML = inner;
            more = true;
          }
        }
      });
      if (!more) break;
    }
  }

  function processRoot(root) {
    root.querySelectorAll(SELECTORS).forEach(processOne);
  }

  function releasePrep() {
    var docEl = document.documentElement;
    if (docEl.classList.contains('rm-prep')) docEl.classList.remove('rm-prep');
  }

  // Toggle handler
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.rm-toggle');
    if (!btn) return;
    var rest = document.getElementById(btn.getAttribute('aria-controls'));
    if (!rest) return;

    var opening = rest.hidden;
    rest.hidden = !opening;
    btn.setAttribute('aria-expanded', String(opening));
    btn.textContent = opening ? 'Read less' : (btn.dataset.origLabel || 'Read more');
  });

  document.addEventListener('DOMContentLoaded', function () {
    processRoot(document);
    requestAnimationFrame(releasePrep);
  });
  document.addEventListener('shopify:section:load', function (e) {
    var el = document.getElementById(e.detail.sectionId);
    if (el) processRoot(el);
    releasePrep();
  });
  window.addEventListener('load', releasePrep);
})();
 